import React from 'react';
import { MobileContainer } from '@components/organism/MobileContainer';
import { TermsAndConditions } from '@components/molecules/TermsAndConditions';

export function TermsAndConditionsPage() {
    return (
        <MobileContainer>
            <TermsAndConditions />
        </MobileContainer>
    );
}
